export const res = {
  loadingAppTitle: {
    is: 'Fylgstu með símanum',
    en: 'Check your Landsbanki app',
    pl: 'Sprawdź w swoim aplikację Landsbanki',
  } as const,
  loadingAppDescription: {
    is: `Landsbankaappið mun biðja þig um auðkenningu. Ef þú færð ekki tilkynningu í símann getur þú skráð þig inn í Landsbankaappið og klárað auðkenninguna.`,
    en: `An authentication request was sent to your Landsbanki app.`,
    pl: `Wniosek o dokonanie identyfikacji został wysłany na Twoją aplikację bankową.`,
  } as const,
  completedAppTitle: {
    is: 'Auðkenningu lokið',
    en: 'Authentication completed',
    pl: 'Ukończono proces identyfikacji',
  } as const,
  completedAppDescription: {
    is: `Hinkraðu augnablik á meðan við sendum þig á næstu síðu`,
    en: `Please wait while we redirect you to the next page`,
    pl: `Proszę czekać, przekierowujemy Cię na następną stronę`,
  } as const,
};
